import { render, staticRenderFns } from "./DraftIdea.vue?vue&type=template&id=56ab5567&"
import script from "./DraftIdea.vue?vue&type=script&lang=js&"
export * from "./DraftIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports